import { Select as AntdSelect } from 'antd'

export const Select = AntdSelect
